import {CorePortalDatatablePredefinedViewConfig} from '@app/core-portal';
import {
  DataTableColumnDto,
  DataTableFilterDto,
  DataTableFilterType,
  FilterKind,
  FilterOperators
} from "@app/core-shared";

export function provideDatatablePredefinedViewConfig(): CorePortalDatatablePredefinedViewConfig {
  return {
    ...provideManagementDatatablePredefinedViewConfig()
  };
}

function provideManagementDatatablePredefinedViewConfig(): CorePortalDatatablePredefinedViewConfig {
  return {
    /* Contact List */
    ContactListComponent: [
      {
        name: 'core-portal.master-data.subtitles.active-contacts',
        filters: [
          {
            type: DataTableFilterType.ByTransfer,
            operator: FilterOperators.Default,
            property: 'isFree',
            kind: FilterKind.Default,
            value: 'true'
          } as DataTableFilterDto
        ]
      },
      {
        name: 'core-portal.master-data.subtitles.not-active-contacts',
        filters: [
          {
            type: DataTableFilterType.ByTransfer,
            operator: FilterOperators.Default,
            property: 'isFree',
            kind: FilterKind.Default,
            value: 'false'
          } as DataTableFilterDto
        ]
      }
    ]
  }
}

